export default function AuthenticationContent() {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">API Key Authentication</h3>
      <p className="mb-4">
        Public API endpoints that access law-firm-owned data accept an API key
        through the combined law firm member or API key authentication scheme.
        Send the key as a UUID in the <code>X-API-Key</code> request header.
      </p>
      <ul className="list-disc pl-6 mb-4">
        <li>
          Do not send an invalid <code>Authorization</code> header together
          with an API key. If an <code>Authorization</code> header is present,
          the backend validates the Bearer token path first.
        </li>
        <li>
          API keys are scoped to a LawFirm and are accepted only while active.
        </li>
        <li>
          The backend validates the request <code>Origin</code> header, or the
          normalized <code>Referer</code> origin when <code>Origin</code> is not
          present, against the key's configured origin pattern.
        </li>
        <li>
          Some intake endpoints allow anonymous access, but associated
          CaseFiles and referenced entities can still enforce access rules.
        </li>
      </ul>

      <h3 className="text-xl font-semibold mb-3">Obtaining an API Key</h3>
      <p className="mb-4">To obtain an API key, follow these steps:</p>
      <ol className="list-decimal pl-6 mb-4">
        <li>Ensure you have a Justin Legal account with admin rights</li>
        <li>
          Log in to{" "}
          <a
            href="https://portal.justin-legal.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            Justin Legal Portal
          </a>
          .
        </li>
        <li>
          Navigate to:
          <ul className="list-disc pl-6">
            <li>Einstellungen &gt; API </li>
          </ul>
        </li>
        <li>Request an API key from this section.</li>
        <li>
          Provide a description and an origin pattern that matches the web
          origins allowed to use the key.
        </li>
      </ol>

      <h3 className="text-xl font-semibold mb-3">Security Considerations</h3>
      <p className="mb-4">
        The origin pattern is a regular expression. Keep it as narrow as
        possible, for example matching only your production domain and any
        approved staging domains. Deactivate or delete keys that are no longer
        used.
      </p>
    </div>
  );
}
